package org.hs_soft.runmynesto.domain.model.home.product.product_item_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ProductItemModel(
    @SerialName("data")
    val data: Data?=null,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)